import React from "react";
import Message from "../../../i18n/Message";
import useSubscriptionGate from "./useSubscriptionGate";

import "./subscription.scss";

/**
 * Header badge. Shows:
 *  - the trial countdown + "Add Card" while trialing (color shifts as the deadline nears),
 *  - an "expired" state once the trial/paid period lapses (read-only), and
 *  - a payment-problem warning + "Fix payment" for an active paid subscription whose charge failed.
 * Renders nothing for a healthy active paid subscription.
 */
const TrialBadge = () => {
  const {
    subscription,
    trialInProgress,
    daysLeft,
    hasPaymentProblem,
    isReadOnly,
    openUpgrade,
  } = useSubscriptionGate();

  if (!subscription) {
    return null;
  }

  // Active paid subscription with a failed charge.
  if (hasPaymentProblem && !isReadOnly && !trialInProgress) {
    return (
      <div className="trial_badge problem">
        <span className="trial_badge_text">
          <Message id="payment_problem_short" />
        </span>
        <button
          type="button"
          className="trial_badge_btn danger"
          onClick={() => openUpgrade()}
        >
          <Message id="fix_payment" />
        </button>
      </div>
    );
  }

  // Only relevant while trialing or at/after expiry.
  if (!trialInProgress && !isReadOnly) {
    return null;
  }

  let stateClass = "";
  if (daysLeft <= 0) {
    stateClass = "expired";
  } else if (daysLeft < 4) {
    stateClass = "soon";
  }

  return (
    <div className={"trial_badge " + stateClass}>
      <span className="trial_badge_text">
        {daysLeft <= 0 ? (
          <Message id="trial_expired" />
        ) : daysLeft === 1 ? (
          <Message id="trial_one_day_left" />
        ) : (
          <Message id="trial_days_left" values={{ count: daysLeft }} />
        )}
      </span>
      <button
        type="button"
        className="trial_badge_btn"
        onClick={() => openUpgrade()}
      >
        <Message id="add_card" />
      </button>
    </div>
  );
};

export default TrialBadge;
